import { Packet, PacketType } from "./packet";

/** what the browser should do (see Player._deliverTick on the server) */
export enum RewindMode {
    /** you died and pressed Watch: clear the world, play the rewind animation, then the replay of your death */
    Death,
    /** you're watching a game from the lobby: the feed is 15 s behind live, so it starts after a short countdown */
    Watch,
    /** switching whose view you watch: clear the world quietly, the new view (from a full snapshot) follows */
    Reset,
    /** the death replay reached the moment of death: from here on it's spectating (seconds: how far behind live) */
    Caught,
    /**
     * sent live, the moment the match ends, to everyone watching it behind live: it's over, and their view still
     * plays its last moments (seconds: how long until the end reaches their screen)
     */
    MatchOver,
    /** in the delayed view: the moment the match ended has reached the screen (seconds: how far behind live) */
    Ended
}

export interface RewindData {
    readonly type: PacketType.Rewind
    /** how far behind live the view is (seconds) */
    readonly seconds: number
    readonly mode: RewindMode
}

export const RewindPacket = new Packet<RewindData>(PacketType.Rewind, {
    serialize(stream, data) {
        stream.writeUint8(Math.max(0, Math.min(255, Math.round(data.seconds))));
        stream.writeUint8(data.mode ?? RewindMode.Death);
    },
    deserialize(stream, data) {
        data.seconds = stream.readUint8();
        data.mode = stream.readUint8() as RewindMode;
    }
});
